var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUniversalSearchIcon = function SvgUniversalSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#212121",
    fillRule: "nonzero",
    stroke: "#212121",
    opacity: 0.814
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.803 2.8a6.124 6.124 0 0 1 8.661-.012 6.127 6.127 0 0 1 .223 8.442l.467.467a.968.968 0 0 1 1.369 0l3.194 3.194a.968.968 0 0 1 0 1.37l-.457.456a.968.968 0 0 1-1.368 0L11.7 13.523a.968.968 0 0 1 0-1.37l-.468-.467a6.124 6.124 0 0 1-8.65-.438A6.127 6.127 0 0 1 2.803 2.8Zm9.351 10.266 3.194 3.194c.126.126.33.126.456 0l.456-.456a.323.323 0 0 0 0-.456l-3.193-3.194a.33.33 0 0 0-.456 0l-.457.456a.323.323 0 0 0 0 .456ZM3.26 11.013a5.483 5.483 0 0 0 7.755 0 5.486 5.486 0 0 0 0-7.757 5.483 5.483 0 0 0-7.755 0 5.492 5.492 0 0 0 0 7.757Z",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.946 3.713.456.456a4.2 4.2 0 0 0 0 5.931l-.456.457a4.845 4.845 0 0 1 0-6.844Z",
    strokeWidth: 0.2
  }))));
};
export default SvgUniversalSearchIcon;